import { END_APP_LOADING, EndAppLoading, START_APP_LOADING, StartAppLoading } from './app.types';


export const startAppLoading = (): StartAppLoading => ({ type: START_APP_LOADING });

export const endAppLoading = (): EndAppLoading => ({ type: END_APP_LOADING });
